const ZIP_MIME_TYPES = new Set([
  "application/zip",
  "application/x-zip-compressed",
  "application/x-zip",
]);

/** True when the file should be sent to POST /v1/files/expand instead of POST /v1/files. */
export function isZipArchiveFile(file: File): boolean {
  if (ZIP_MIME_TYPES.has(file.type)) return true;
  return file.name.toLowerCase().endsWith(".zip");
}
